<template>
    <v-row>
        <v-col>
            <v-card elevation="0">
                <v-card-title>
                    {{ data.details.originTown }}
                    <v-icon x-small class="_arrow">fas fa-arrow-right</v-icon>
                    {{ data.details.unloadingTown }}
                </v-card-title>
                <v-card-text>
                    <v-card>
                        <v-data-table
                            :key="anIncreasingNumber"
                            :headers="headersPackage"
                            :items="data.content.cases.sizing.map((i, j) => ({ ...i, id: j.toString() }))"
                            :hide-default-footer="true"
                            @click:row="clickRow"
                            show-expand
                            :expanded.sync="expanded"
                            item-key="id"
                            skin="elevation-1"
                            :itemsPerPage="-1"
                            multi-sort
                        >
                            <template v-slot:expanded-item="{ item }">
                                <td style="padding: 0" colspan="6">
                                    <v-data-table
                                        class="elevation-2 secondary-grey"
                                        :headers="headersItems"
                                        :items="itemsForCaseNumber(item.caseNumber)"
                                        :hide-default-footer="true"
                                        item-key="id"
                                        :itemsPerPage="100"
                                    />
                                </td>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: ['data'],
    data() {
        return {
            expanded: [],
            singleExpand: false,
            anIncreasingNumber: 0
        };
    },
    computed: {
        ...mapGetters(['getClientName']),
        headersItems() {
            return [
                {
                    text: this.$t('trackandtrace.content.header.vendorPartNumber'),
                    value: 'vendorPartNumber',
                    align: 'center'
                },
                {
                    text: this.$t('trackandtrace.content.header.clientProductReference'),
                    value: 'clientProductReference',
                    align: 'center'
                },
                {
                    text: this.$t('trackandtrace.content.header.itemDescription'),
                    value: 'itemDescription',
                    align: 'center'
                },
                {
                    text: this.$t('trackandtrace.content.header.quantity'),
                    value: 'quantity',
                    align: 'center'
                },
                {
                    text: this.$t('trackandtrace.content.header.serialNumber'),
                    value: 'serialNumber',
                    align: 'center'
                }
            ];
        },
        headersPackage() {
            return [
                {
                    text: this.$t('trackandtrace.content.header.caseNumber'),
                    value: 'caseNumber',
                    align: 'center'
                },
                {
                    text: this.$t('trackandtrace.content.header.weight'),
                    value: 'weight',
                    align: 'center'
                },

                {
                    text: this.$t('trackandtrace.content.header.length'),
                    value: 'length',
                    align: 'center'
                },
                {
                    text: this.$t('trackandtrace.content.header.width'),
                    value: 'width',
                    align: 'center'
                },
                {
                    text: this.$t('trackandtrace.content.header.height'),
                    value: 'height',
                    align: 'center'
                }
            ];
        }
    },
    methods: {
        itemsForCaseNumber(caseNumber) {
            const array =
                this.data.content.cases.items?.filter(item => item.caseNumber === caseNumber) ||
                this.data.content.cases.groups?.filter(item => item.caseNumber === caseNumber);

            return array.map((i, j) => ({ ...i, id: j.toString() }));
        },
        clickRow(row) {
            const array = JSON.parse(JSON.stringify(this.expanded));
            const index = array.findIndex(i => i.id === row.id);
            if (index > -1) {
                array.splice(index, 1);
            } else {
                array.push(row);
            }
            this.expanded = array;
            this.anIncreasingNumber += 1;
        }
    },
    filters: {
        uppercase(value) {
            return value.toUpperCase();
        }
    }
};
</script>

<style lang="scss" scoped>
._arrow {
    margin: 0 10px;
}
</style>
